import React, {useState, useEffect} from 'react';
import Modal from 'react-bootstrap/Modal';
import { Link, useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { Loading } from '~/components';
import { FormCad } from '../components';
import initialData from './initialData';
import schema from './schema'
import { updateMunicipio, showMunicipio, loadMunicipios } from '~/store/modules/municipio/action';



const Edit = () => {
  let history = useHistory();
  const [municipioEdit, setMunicipioEdit] = useState(initialData);
  const [errorsValidate, setErrorsValidate] = useState([]);
  const [updated, setUpdated] = useState(false);
  const dispatch = useDispatch();
  const { municipio_id } = useParams();
  const { estado_id } = useParams();
  const { municipio, errors } = useSelector(({ MunicipioReducer }) => MunicipioReducer);

  useEffect(() => {
    dispatch(showMunicipio(municipio_id));
  }, [dispatch, municipio_id]);

  useEffect(() => {
    if (municipio.id === parseInt(municipio_id)) {
      setMunicipioEdit(municipio);
    }
  }, [municipio, municipio_id]);

  useEffect(() => {
    if (errors.status && errors.status === 422) {
      let server_errors = {};
      const response_errors = errors.data.errors;
      for (let name of Object.keys(response_errors)) {
        Object.assign(server_errors, { [name]: response_errors[name][0] });
      }
      setErrorsValidate(server_errors);
    }
    if(errors.update) {
      setUpdated(true);
    }
  }, [errors]);

  useEffect(() => {
    if (updated) {
      Swal.fire('Sucesso', 'Entidade atualizada com sucesso!', 'success').then(
        () => {
          history.goBack();
          dispatch(loadMunicipios(estado_id));
        }
      );
    }
  }, [updated, history, dispatch, estado_id]);

  const handleClose = () => {
    history.push(`/estado/${estado_id}/detalhe`);
    dispatch(loadMunicipios(estado_id));
  };


  const handleSubmit = async event => {
    event.preventDefault();
    if (!schema.isValidSync(municipioEdit)) {
      let yup_errors = {};
      schema.validate(municipioEdit, { abortEarly: false }).catch(err => {
        for (let error of err.inner) {
          const { path, message } = error;
          Object.assign(yup_errors, { [path]: message });
        }
        setErrorsValidate(yup_errors);
      });
    } else {
      await dispatch(updateMunicipio(municipioEdit, municipio_id));
    }

  };
  return (
    <Modal
      aria-labelledby="contained-modal-title-vcenter"
      dialogClassName="modal-xl"
      onHide={handleClose}
      show
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Municipio</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="card">
          <div className="card-header">
            <h2 className="card-title">Editar</h2>
          </div>
          <div className="card-body">
            {municipio.id === parseInt(municipio_id) ? (
              <FormCad
                errors={errorsValidate}
                municipio={municipioEdit}
                handleSubmit={handleSubmit}
                schema={schema}
                setMunicipio={setMunicipioEdit}
              />
            ) : (
              <Loading />
            )}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Link
          className="btn btn-default"
          to={`/estado/${estado_id}/detalhe`}
        >
          <i className="fa fa-window-close" /> Cancelar
        </Link>
        <button
          className="btn btn-success"
          form="form_municipio"
          type="submint"
        >
          {' '}
          <i className="fa fa-save" /> Salvar
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default Edit;
